import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';
import {
    Form, Input, Button, 
    message,
} from 'antd';

class SsubHeaderForm extends PureComponent {

    state = {

    }

    componentDidMount = () => {
        let defConfig = JSON.parse(localStorage.getItem('configApp'));
        this.setState(defConfig);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({
                    subheader: values.alamat_rs
                }, () => this.saveToLocal());
                message.success("Setting Tersimpan.");
            }
        });
    }

    saveToLocal = () => {
        let defConfig = JSON.parse(localStorage.getItem('configApp'));
        
        let newConfig = Object.assign({}, defConfig, {
            subheader: this.state.subheader
        });

        localStorage.setItem('configApp', JSON.stringify(newConfig));
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        return (
            <div>
                <Form onSubmit={this.handleSubmit} hideRequiredMark>
                    <Form.Item {...formItemLayout} label="Alamat RS">
                        {getFieldDecorator('alamat_rs', {
                            rules: [{
                                required: true, message: 'Alamat Rumah Sakit Tidak Boleh Kosong!',
                            }],
                            initialValue: this.state.subheader
                        })(
                            <Input />
                        )}
                    </Form.Item>
                    <Form.Item {...tailFormItemLayout}>
                        <Button type="primary" htmlType="submit">Terapkan</Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

const WrappedSsubHeaderForm = Form.create({ name: 'ssheader' })(SsubHeaderForm);

SsubHeaderForm.propTypes = {

};

export default WrappedSsubHeaderForm;